export default __webpack_public_path__ + "static/media/Volume Off.9a516373.svg";